import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { tblShape } from '../../utils';

export default Vue.component('edit-table', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['viewport']),
    maxColCount() {
      return this.droplet.header.length <= 9;
    },
    maxRowCount() {
      return this.droplet.body.length <= 19;
    },
    minColCount() {
      return this.droplet.header.length > 1;
    },
    minRowCount() {
      return this.droplet.body.length > 1;
    },
  },
  data() {
    return {
      activeRow: null,
      activeCol: null,
    };
  },
  name: 'edit-table',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    addColumn() {
      if (this.maxColCount) {
        const payload = {};
        payload.drp = this.droplet;
        payload.header = tblShape()();
        const rows = this.droplet.body;
        const list = [];
        _.forEach(rows, () => {
          list.push(tblShape()());
        });
        payload.cols = list;
        this.promise(this.$store.dispatch('addTableColumn', payload), 'adding column');
      }
    },
    removeColumn(i) {
      if (this.minColCount) {
        const payload = {};
        payload.drp = this.droplet;
        payload.index = i;
        this.promise(this.$store.dispatch('removeTableColumn', payload), 'removing column');
      }
    },
    addRow() {
      if (this.maxRowCount) {
        const payload = {};
        payload.drp = this.droplet;
        payload.row = {
          cols: [],
        };
        _.forEach(this.droplet.header, () => {
          payload.row.cols.push(tblShape()());
        });
        this.promise(this.$store.dispatch('addTableRow', payload), 'adding row');
      }
    },
    removeRow(i) {
      if (this.minRowCount) {
        const payload = {};
        payload.drp = this.droplet;
        payload.index = i;
        this.promise(this.$store.dispatch('removeTableRow', payload), 'removing row');
      }
    },
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    promise(action, error) {
      const promise = new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in Tables: ${error}`));
        }
      });
      promise.then(() => {
        this.$vnode.context.unBindPlugin();
        this.$vnode.context.bindPlugin();
      });
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.$emit('css-generator');
      this.activeRow = null;
      this.activeCol = null;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/table/components/_edit-options/index.js